import React from 'react';

const PublicReportPage = () => {
  return (
    <div className="code-report-page">
      <h1>Report a public issue</h1>
      <p>This page will allow you to report issues with shared public infrastructure such as streetlights, roads, parks, and public buildings.</p>
    </div>
  );
};

export default PublicReportPage;

